import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/auth';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const status = useAuthStore.getState().status;
    if (status === 'authed') throw redirect({ to: '/dashboard' });
    if (status === 'pre_mfa' || status === 'needs_mfa') throw redirect({ to: '/mfa' });
    throw redirect({ to: '/login' });
  },
});
